import { attr, Model } from 'redux-orm';
import { createAction, createLoadConst } from '../util';

export default class ExternalAccountAudit extends Model {
  static get modelName() {
    return 'ExternalAccountAudit';
  }

  static reducer({ type, data }, ExternalAccountAudit) {
    switch (type) {
      case LOAD.SUCCESS:
        ExternalAccountAudit.delete();
        if (data.response) {
          data.response.forEach((r) => ExternalAccountAudit.upsert(r));
        }
        break;

      default:
        break;
    }
  }

  /**
   * Declaring all data fields is recommended as the library doesn't have to
   * redefine getters and setters when instantiating Models
   * */
  static get fields() {
    return {
      byAdminUserId: attr(),
      bySystemUser: attr(),
      byUserId: attr(),
      changelog: attr(),
      extddaId: attr(),
      id: attr(),
      logAt: attr(),
      logOp: attr(),
      time: attr(), // derived
      title: attr(), // derived
    };
  }
}

export const LOAD = createLoadConst(ExternalAccountAudit.modelName);
export const load = createAction(LOAD);
